import React, { useState, Fragment } from 'react';
import { SparklesIcon } from 'lucide-react';
import { pokemonData } from '../data/pokemonData';
export function PokemonDetail({
  pokemon,
  isShiny,
  onToggleShiny,
  onSelectEvolution
}) {
  const [activeTab, setActiveTab] = useState('stats');
  const getTypeColor = type => {
    const typeColors = {
      Normal: 'bg-gray-400',
      Fire: 'bg-red-500',
      Water: 'bg-blue-500',
      Electric: 'bg-yellow-400',
      Grass: 'bg-green-500',
      Ice: 'bg-blue-200',
      Fighting: 'bg-red-700',
      Poison: 'bg-purple-500',
      Ground: 'bg-yellow-600',
      Flying: 'bg-indigo-300',
      Psychic: 'bg-pink-500',
      Bug: 'bg-lime-500',
      Rock: 'bg-yellow-800',
      Ghost: 'bg-purple-700',
      Dragon: 'bg-indigo-700',
      Dark: 'bg-gray-700',
      Steel: 'bg-gray-500',
      Fairy: 'bg-pink-300'
    };
    return typeColors[type] || 'bg-gray-400';
  };
  const imageUrl = isShiny && pokemon.shinyImage ? pokemon.shinyImage : pokemon.image;
  // Check if a Pokémon exists in our data
  const isPokemonAvailable = pokemonName => {
    return pokemonData.some(p => p.name.toLowerCase() === pokemonName.toLowerCase());
  };
  // Handle evolution click
  const handleEvolutionClick = evolutionName => {
    if (isPokemonAvailable(evolutionName)) {
      const selectedPokemon = pokemonData.find(p => p.name.toLowerCase() === evolutionName.toLowerCase());
      onSelectEvolution(selectedPokemon);
    }
  };
  return <div className="bg-slate-700/60 rounded-lg overflow-hidden border border-slate-600 shadow-lg" data-id="element-226">
      <div className="p-6 pb-4" data-id="element-227">
        <div className="flex flex-col md:flex-row gap-6" data-id="element-228">
          <div className="md:w-1/3" data-id="element-229">
            <div className="bg-slate-600/50 rounded-lg p-4 flex justify-center items-center relative" data-id="element-230">
              <img src={imageUrl} alt={pokemon.name} className="h-48 w-48 object-contain" data-id="element-231" />
              <button className={`absolute top-3 right-3 p-2 rounded-full ${isShiny ? 'bg-yellow-500' : 'bg-slate-700'} hover:opacity-90 transition-colors`} onClick={onToggleShiny} title={isShiny ? 'Show normal form' : 'Show shiny form'} data-id="element-232">
                <SparklesIcon className={`h-5 w-5 ${isShiny ? 'text-white' : 'text-yellow-300'}`} data-id="element-233" />
              </button>
              {isShiny && <div className="absolute bottom-3 left-3 bg-yellow-500 text-white text-xs px-2 py-1 rounded-full font-medium" data-id="element-234">
                  Shiny
                </div>}
            </div>
            <div className="mt-4" data-id="element-235">
              <h2 className="text-2xl font-bold text-white" data-id="element-236">{pokemon.name}</h2>
              <p className="text-gray-400" data-id="element-237">
                #{pokemon.id.toString().padStart(3, '0')}
              </p>
              <div className="flex gap-2 mt-2" data-id="element-238">
                {pokemon.types.map(type => <span key={type} className={`${getTypeColor(type)} px-3 py-1 rounded-full text-sm font-medium text-white`} data-id="element-239">
                    {type}
                  </span>)}
              </div>
              {pokemon.legendary && <div className="mt-3" data-id="element-240">
                  <span className="bg-yellow-600 text-white text-sm px-3 py-1 rounded-full" data-id="element-241">
                    Legendary
                  </span>
                </div>}
            </div>
          </div>
          <div className="md:w-2/3" data-id="element-242">
            <div className="border-b border-slate-600" data-id="element-243">
              <nav className="flex" data-id="element-244">
                <button className={`py-2 px-4 font-medium ${activeTab === 'stats' ? 'text-yellow-300 border-b-2 border-yellow-300' : 'text-gray-300 hover:text-white'}`} onClick={() => setActiveTab('stats')} data-id="element-245">
                  Stats
                </button>
                <button className={`py-2 px-4 font-medium ${activeTab === 'about' ? 'text-yellow-300 border-b-2 border-yellow-300' : 'text-gray-300 hover:text-white'}`} onClick={() => setActiveTab('about')} data-id="element-246">
                  About
                </button>
                <button className={`py-2 px-4 font-medium ${activeTab === 'evolution' ? 'text-yellow-300 border-b-2 border-yellow-300' : 'text-gray-300 hover:text-white'}`} onClick={() => setActiveTab('evolution')} data-id="element-247">
                  Evolution
                </button>
              </nav>
            </div>
            <div className="py-4" data-id="element-248">
              {activeTab === 'stats' && <div className="space-y-4" data-id="element-249">
                  {Object.entries(pokemon.stats).map(([stat, value]) => <div key={stat} className="flex items-center" data-id="element-250">
                      <div className="w-24 text-gray-300 capitalize" data-id="element-251">
                        {stat}
                      </div>
                      <div className="flex-1" data-id="element-252">
                        <div className="h-4 bg-slate-600 rounded-full overflow-hidden" data-id="element-253">
                          <div className="h-full bg-blue-500 rounded-full" style={{
                      width: `${value / 255 * 100}%`
                    }} data-id="element-254"></div>
                        </div>
                      </div>
                      <div className="w-10 text-right text-white font-medium ml-2" data-id="element-255">
                        {value}
                      </div>
                    </div>)}
                  <div className="mt-2 text-gray-300 text-sm" data-id="element-256">
                    <p data-id="element-257">
                      Total:{' '}
                      {Object.values(pokemon.stats).reduce((a, b) => a + b, 0)}
                    </p>
                  </div>
                </div>}
              {activeTab === 'about' && <div className="text-gray-200" data-id="element-258">
                  <p className="mb-4" data-id="element-259">{pokemon.description}</p>
                  <div className="grid grid-cols-2 gap-4 mt-4" data-id="element-260">
                    <div data-id="element-261">
                      <h4 className="text-gray-400 text-sm" data-id="element-262">Height</h4>
                      <p data-id="element-263">{pokemon.height} m</p>
                    </div>
                    <div data-id="element-264">
                      <h4 className="text-gray-400 text-sm" data-id="element-265">Weight</h4>
                      <p data-id="element-266">{pokemon.weight} kg</p>
                    </div>
                    <div data-id="element-267">
                      <h4 className="text-gray-400 text-sm" data-id="element-268">Region</h4>
                      <p data-id="element-269">{pokemon.region}</p>
                    </div>
                    <div data-id="element-270">
                      <h4 className="text-gray-400 text-sm" data-id="element-271">Abilities</h4>
                      <p data-id="element-272">{pokemon.abilities.join(', ')}</p>
                    </div>
                  </div>
                  {pokemon.trivia && <div className="mt-6" data-id="element-273">
                      <h4 className="text-yellow-300 font-medium mb-2" data-id="element-274">
                        Fun Facts
                      </h4>
                      <ul className="list-disc pl-5 space-y-2" data-id="element-275">
                        {pokemon.trivia.map((fact, index) => <li key={index} data-id="element-276">{fact}</li>)}
                      </ul>
                    </div>}
                </div>}
              {activeTab === 'evolution' && <div data-id="element-277">
                  {pokemon.evolutions && pokemon.evolutions.length > 0 ? <div className="flex items-center justify-center space-x-4" data-id="element-278">
                      {pokemon.evolutions.map((evolution, index) => <Fragment key={evolution.name} data-id="element-279">
                          <div className="text-center" data-id="element-280">
                            <div className={`relative ${isPokemonAvailable(evolution.name) ? 'cursor-pointer transform hover:scale-110 transition-transform' : ''}`} onClick={() => handleEvolutionClick(evolution.name)} data-id="element-281">
                              <img src={evolution.image} alt={evolution.name} className="h-24 w-24 object-contain mx-auto rounded-lg" data-id="element-282" />
                            </div>
                            <p className="text-white mt-2" data-id="element-283">{evolution.name}</p>
                            {evolution.level && <p className="text-xs text-gray-400" data-id="element-284">
                                Level {evolution.level}
                              </p>}
                          </div>
                          {index < pokemon.evolutions.length - 1 && <div className="text-gray-400" data-id="element-285">→</div>}
                        </Fragment>)}
                    </div> : <p className="text-center text-gray-300" data-id="element-286">
                      This Pokémon does not evolve.
                    </p>}
                  {pokemon.typeWeaknesses && <div className="mt-8" data-id="element-287">
                      <h4 className="text-yellow-300 font-medium mb-3" data-id="element-288">
                        Type Effectiveness
                      </h4>
                      <div className="grid grid-cols-2 gap-4" data-id="element-289">
                        <div data-id="element-290">
                          <h5 className="text-red-400 mb-2" data-id="element-291">Weaknesses</h5>
                          <div className="flex flex-wrap gap-2" data-id="element-292">
                            {pokemon.typeWeaknesses.map(type => <span key={type} className={`${getTypeColor(type)} px-2 py-1 rounded-full text-xs font-medium text-white`} data-id="element-293">
                                {type}
                              </span>)}
                          </div>
                        </div>
                        {pokemon.typeResistances && <div data-id="element-294">
                            <h5 className="text-green-400 mb-2" data-id="element-295">Resistances</h5>
                            <div className="flex flex-wrap gap-2" data-id="element-296">
                              {pokemon.typeResistances.map(type => <span key={type} className={`${getTypeColor(type)} px-2 py-1 rounded-full text-xs font-medium text-white`} data-id="element-297">
                                  {type}
                                </span>)}
                            </div>
                          </div>}
                      </div>
                    </div>}
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}